function clonePlainObject(value) {
    if (!value || typeof value !== 'object') {
        return {};
    }
    return JSON.parse(JSON.stringify(value));
}

function getContainerSaveData(containerObject) {
    if (!containerObject || !containerObject.resource) {
        return null;
    }
    return {
        resourceId: containerObject.resource.id,
        resourceName: containerObject.resource.name,
        params: clonePlainObject(containerObject.params),
        radius: containerObject.radius,
        height: containerObject.height,
        type: 'container'
    };
}

module.exports = {
    getContainerSaveData,
};
